<!--确认退款选择页面-->
<template>
  <el-dialog title="退款方式选择"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog" :append-to-body="true"
             center
             :close-on-click-modal="false"
             :modal="true">
    <div>原订单：<span style="margin-right: 20px;cursor: pointer" @click="lookDetails()"><b>{{orderinfo.parenterpserial?orderinfo.parenterpserial:'无'}}</b></span><span style="margin-right: 40px"><b>{{(orderinfo.oldstatus==400||orderinfo.oldstatus==500)?'已发货':'未出库'}}</b></span><span style="color: red"><b>{{paymethodOld}}</b><b
      v-if="paymethodOld!=''&&paymethodOld!='使用优惠券'&&Math.abs(cstagreementDOtuihuo.discount)>0">+</b><b
      v-if="Math.abs(cstagreementDOtuihuo.discount)>0&&paymethodOld!='使用优惠券'">优惠券</b></span></div>
    <div v-if="Object.keys(cstagreementDOtuihuo).length>0">本次应退金额：<span style="color: red"><b
      v-if="Math.abs(cstagreementDOtuihuo.yfk)>0">{{Math.abs(cstagreementDOtuihuo.yfk)}}元</b><b
      v-if="Math.abs(cstagreementDOtuihuo.yfk)>0&&Math.abs(cstagreementDOtuihuo.discount)>0">+</b><b
      v-if="Math.abs(cstagreementDOtuihuo.discount)>0">返回优惠券{{Math.abs(cstagreementDOtuihuo.discount)}}元</b>
      <b style="padding-left: 200px" v-if="isshowayjs&&settingmenthod=='200'">月结客户：请做应收调整或换货</b></span>
    </div>
    <el-radio-group v-model="refund" style="padding-left: 30px;padding-top: 20px;padding-bottom: 10px">
      <el-radio :label="1" v-if="allowrefund&&isshowpaymethod&&!isshowayjs" border>{{'退到：'+paymethod}}</el-radio>
      <el-radio :label="2" v-if="isshowayjs&&settingmenthod!='200'" border>无需退钱</el-radio>
      <el-radio :label="3" v-if="!isshowayjs||!(isshowayjs&&settingmenthod!='200')" border>线下已转</el-radio>
      <el-radio :label="4" v-if="(allowrefund&&isshowpaymethod&&!isshowayjs&&paymethod!='余额')||showYE" border>{{'退到：余额'}}</el-radio>
      <el-radio :label="5" border>减铺货</el-radio>
      <el-radio :label="6" border v-if="(orderinfo.oldstatus==400||orderinfo.oldstatus==500)">换货</el-radio>
    </el-radio-group>
    <div v-if="refund==6" style="line-height:40px"><span style="color: red"> * </span>换货单号：<el-button size="mini" style="padding: 4px 10px" round @click="searchGoods">选择</el-button> {{changeerpserial}}
      <span style="padding-left: 40px">{{changemoney}}</span></div>
    <textarea style="width: 100%;height: 60px" v-model="remark" placeholder="退款说明"></textarea>
    <div v-html="getLiuYan(orderinfo.remark)"
         style="text-align: left;padding-left: 5px;padding-right: 5px;" class="color-grey"></div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" class="qrbtn" :loading="loading" @click="saveData">确认</el-button>
      <OrderCustomerSelect ref="OrderCustomerSelect1" @afterSelect="afterSelectOrder" :showlookprice="true"></OrderCustomerSelect>
    </div>
  </el-dialog>
</template>
<script>
  import {refundList, returngoodssave} from '@/api/set/csagreement';
  import {saveData} from '@/api/set/handlelog';
  import {checkModuleRight} from '@/api/login'
  import {getBySerial} from "../../../api/set/externaldept";
  import {getRemark} from '@/plugin/ordercommon'
  import OrderCustomerSelect from '../../account/OrderCustomerSelect';

  export default {
    name: "ConfirmRefundEdit",
    data() {
      return {
        allowrefund: false,
        loading: true,
        dialogFormVisible: false,
        orderinfo: {},
        showtitle: '',
        erpserial: "",
        unitguid: "",
        parentguid: '',
        refund: '',
        paymethod: '',
        showYE: false,
        paymethodOld: '',
        changeerpserial:'',
        changemoney:'',
        remark: '',
        isshowpaymethod: false,
        isshowayjs: false,
        settingmenthod:'',
        formLabelWidth: '120px',
        cstagreementDOtuihuo: {},//退货单
      }
    },
    methods: {
      getLiuYan(remark) {
        return getRemark(remark);
      },
      //处理日志
      handlelog(remark) {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1

        handlelog.casestepname = '退款完成'
        handlelog.remark = '退款完成' + remark
        saveData(handlelog).then(response => {
        })
      },
      lookDetails() {
        if (this.orderinfo.parenterpserial)
          this.$parent.lookDetails({erpserial: this.orderinfo.parenterpserial, unitguid: this.orderinfo.parentguid})
      },
      afterSelectOrder(erpserial,changemoney) {
        this.changeerpserial = erpserial;
        this.changemoney = changemoney;
      },
      initData(item) {
        this.settingmenthod=''
        this.orderinfo = item;
        this.initForm()
        if(!this.orderinfo.jxcformdetailDOList||this.orderinfo.jxcformdetailDOList.length==0) {
          return;
        }

        if (!item.parenterpserial) {//手工添加的订单
          getBySerial({customerserial: item.customerserial}).then(response => {
            this.showYE = response.data.obj.settingmenthod.indexOf('100') > -1
              && response.data.obj.settingmenthod.indexOf('200') > -1;
          })
        }

        this.erpserial = item.erpserial
        this.unitguid = item.unitguid
        this.parentguid = item.parentguid
        this.dialogFormVisible = true;
        this.isshowayjs = false
        refundList({
          parentguid: this.parentguid,
          erpserial: this.erpserial,
          customerserial: item.customerserial
        }).then(response => {
          if (response.data.obj) {
            if (response.data.obj == "youhui") {
              this.isshowayjs = true
              this.refund = 2
              this.paymethodOld = "使用优惠券";
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
              this.settingmenthod=response.data.settingmenthod;
            } else if (response.data.obj == "ayjs") {
              this.isshowayjs = true
              this.refund = 2
              this.paymethodOld = "月结客户";
            } else if (response.data.obj == "yue") {
              this.paymethod = '余额'
              this.isshowpaymethod = true
              this.paymethodOld = response.data.paymethod;
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
              this.refund = 1
            } else {
              this.paymethodOld = response.data.obj[0].paymethod;
              this.cstagreementDOtuihuo = response.data.cstagreementDOtuihuo;
              if (response.data.obj[0].paymethod != '转账') {
                this.paymethod = response.data.obj[0].paymethod
                this.refund = 1
                this.isshowpaymethod = true
              } else {
                this.isshowpaymethod = false
                this.refund = 3
              }
            }
            this.loading = false;
          }
          //console.log(JSON.stringify(this.cstagreementDOtuihuo))
        })
      },
      saveData() {
        let paymenthod = ''
        if (this.refund == 1) {
          paymenthod = this.paymethod
        } else if (this.refund == 2) {
          paymenthod = '按月结算'
        } else if (this.refund == 3) {
          paymenthod = '转账'
        } else if (this.refund == 5) {
          paymenthod = '减铺货'
        } else if (this.refund == 4) {
          paymenthod = '余额'
        } else if (this.refund == 6) {
          paymenthod = '换货'
          if (!this.changeerpserial) {
            this.$message({
              message: '换货订单号必须选择！',
              type: 'error'
            })
            return;
          }
        } else {
          this.$message({
            message: '退款方式必选！',
            type: 'error'
          })
          return;
        }
        this.$confirm('<span style="font-size: larger">您选择的退款方式<b>【'+paymenthod+'】</b>, 是否继续?</span>', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString:true,
          type: 'warning'
        }).then(() => {

          this.loading = true;

          returngoodssave({
            unitguid: this.unitguid,
            refund: paymenthod,
            remark: this.remark,
            changeerpserial: this.changeerpserial
          }).then(response => {
            if (response.data.code == 0) {
              var msg = response.data.errormsg;
              if (!msg || msg == '') {
                this.$message({
                  message: '退款成功！',
                  type: 'success'
                })
              } else {
                this.$message({
                  message: msg,
                  type: 'warning'
                })
              }
              this.handlelog(this.refund + paymenthod);
              this.$emit('bindGrid');
              this.dialogFormVisible = false;
            } else {
              this.loading = false;
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          })

        }).catch(() => {

        });

      },
      searchGoods() {
        if (this.orderinfo.customerserial) {
          var totalnum=0;
          for(let i in this.orderinfo.jxcformdetailDOList){
            totalnum+=Math.abs(parseInt(this.orderinfo.jxcformdetailDOList[i].totalnumber));
          }
          this.$refs.OrderCustomerSelect1.initData(this.orderinfo.customerserial, this.orderinfo.customername,
            this.orderinfo.jxcformdetailDOList[0].seedcode,this.orderinfo.jxcformdetailDOList[0].seedname,totalnum);
        }
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.loading = true;
        this.showYE = false
        this.erpserial = ""
        this.changeerpserial=""
        this.changemoney=""
        this.cstagreementDOtuihuo = {}
      }
    },
    mounted() {
      checkModuleRight({name: 'allowrefund'}).then(reponse => {//是否启用在线退款功能
        this.allowrefund = reponse.data.code == 0;
      });
    },
    components: {
      OrderCustomerSelect
    }
  }
</script>


<style scoped>
  .Hid {
    display: none;
  }

  .ddinfo {
    border-collapse: collapse;
    width: 100%;
    margin-top: 12px;

  }

  .ddinfo td {
    font-size: 14px;
    text-align: center;
    border: 1px solid #E0DFDF;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/ConfirmRefundEdit.vue